// This is here because jest does not support the
// getComputedTextLength function, so we simply mock
// this module instead of an entire function
export function wrappedGetComputedTextLength(element: SVGTextContentElement) {
  return element.getComputedTextLength();
}
